// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"c0211437","239":"45f1e59c","453":"cf08b232","455":"0c007bd5","920":"35e9c20f","977":"20f7fb12"}[chunkId] + ".chunk.js";
};